import { type ReactElement } from 'react'
import { observer } from 'mobx-react-lite'
import { PageScroll } from 'app/components/layout/PageScroll'
import { PageHeaderComponent } from 'app/components/page-header/PageHeaderComponent'
import { useWorkspace } from 'app/utils'
import { OpsDatasetsProvider } from './OpsDatasetsContext'
import { DatasetsPanelComponent } from './DatasetsPanelComponent'

export const OpsDatasetsLayoutComponent = observer(function OpsDatasetsLayoutComponent(): ReactElement {
  const workspaceId = useWorkspace()?.id

  return (
    <PageScroll
      header={
        <PageHeaderComponent
          title="Datasets"
          subTitle="Curate labeled calls with golden extractions to evaluate prompts against."
        />
      }
      contentClassName="pb-14 pt-6"
    >
      <OpsDatasetsProvider key={workspaceId} workspaceId={workspaceId}>
        <DatasetsPanelComponent />
      </OpsDatasetsProvider>
    </PageScroll>
  )
})
